<template>
  <div v-on-click-outside="onClickOutside" :class="props.fit ?? 'w-fit'">
    <div v-bind="$attrs" ref="reference">
      <slot :open="open" :toggle-open="toggleOpen" :set-open="setOpen" :set-closed="setClosed" />
    </div>

    <teleport :to="menuTeleportTo" :disabled="!menuTeleportTo || disabled">
      <gv-transition-dropdown>
        <div
          v-show="open"
          ref="menu"
          class="absolute z-dropdown flex text-clip"
          :style="{
            minWidth: props.minWidth,
          }"
        >
          <slot name="menu" :open="open" :toggle-open="toggleOpen" :set-open="setOpen" :set-closed="setClosed" />
        </div>
      </gv-transition-dropdown>
    </teleport>
  </div>
</template>

<script lang="ts" setup>
import { useFloatingUi, useToggle } from '@/common/composables';
import { ref } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import { GvDropdownProps } from './types';

const props = withDefaults(defineProps<GvDropdownProps>(), {
  fit: true,
  useClickOutside: true,
  floatingUiOptions: undefined,
  menuTeleportTo: undefined,
  minWidth: undefined,
});

const emit = defineEmits<{
  (event: 'setClosed'): void;
}>();

const onClickOutside = () => {
  if (!props.useClickOutside) return;
  onSetClosed();
};

const onSetClosed = () => {
  setClosed();
  emit('setClosed');
};

const { value: open, toggle: toggleOpen, setOn: setOpen, setOff: setClosed } = useToggle();

const reference = ref();
const menu = ref();

useFloatingUi(reference, menu, props.floatingUiOptions);
</script>
